import { z } from "zod";

// Schema para validar o PROJETO (sem campos de área)
export const registerProjectSchema = z.object({
  title: z.string().min(1, { message: "Nome é obrigatório" }),

  owner: z.string().nullable().optional(),

  address: z.string().optional(),
  legal_reserve_deficit: z.string().optional(),
  has_federal_debt: z.string().optional(),

  conservation_unit: z.string().optional(),
  owner_actions_to_preserve_forest: z.string().optional(),

  project_owner: z.object({
    name: z.string().min(1, "Nome obrigatório"),
  
    phone: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
  
    cpf: z.string().optional().nullable(),
    cnpj: z.string().optional().nullable(),
  
    person_type: z.enum(["Física", "Jurídica"], {
      message: "Selecione o tipo de pessoa",
    }),
  }),

  // REMOVIDOS daqui - agora vêm do CreateArea:
  // - total_area
  // - legal_reserve_area
  // - matricula_status
  // - status_car
  // - sicar_code
  // - georeferencing_status
  // - reserve_legal_status
});

// Schema separado para validar cada ÁREA (use no CreateArea)
export const createAreaSchema = z.object({
  name: z.string().min(1, { message: "Nome da área é obrigatório" }),

  vert_responsible: z.string().min(1, { message: "Responsável VERT é obrigatório" }),
  
  adi_responsible: z.string().min(1, { message: "Gestor é obrigatório" }),

  total_area: z
    .string()
    .min(1, { message: "Área total é obrigatória" })
    .refine((val) => !isNaN(parseFloat(val.replace(/\./g, "").replace(",", "."))), {
      message: "Digite um número válido",
    }),

  legal_reserve_area: z
    .string()
    .min(1, { message: "Área de reserva legal é obrigatória" })
    .refine((val) => !isNaN(parseFloat(val.replace(/\./g, "").replace(",", "."))), {
      message: "Digite um número válido",
    }),

  matricula_status: z.string().min(1, { message: "Status da matrícula é obrigatório" }),

  reserve_legal_status: z.string().min(1, { message: "Status da reserva legal é obrigatório" }),

  georeferencing_status: z.string().min(1, { message: "Status do georreferenciamento é obrigatório" }),

  status_car: z.string().min(1, { message: "Status do CAR é obrigatório" }),

  sicar_code: z.string().min(1, { message: "Código SICAR é obrigatório" }),

  other_responsibles: z.array(z.number()).optional(),

  adi_image: z.any().optional(),

  areaNumber: z.number(),

  project: z.string().optional(),
});